import { defineStore } from 'pinia';
import { ref } from 'vue';

type NotificationColor = 'success' | 'error' | 'warning' | 'info';

export const useNotificationStore = defineStore('notification', () => {
  const show = ref(false);
  const message = ref('');
  const color = ref<NotificationColor>('info');
  const timeout = ref(3000);

  function notify(msg: string, type: NotificationColor = 'info', duration = 3000): void {
    message.value = msg;
    color.value = type;
    timeout.value = duration;
    show.value = true;
  }

  function success(msg: string, duration = 3000): void {
    notify(msg, 'success', duration);
  }

  function error(msg: string, duration = 5000): void {
    notify(msg, 'error', duration);
  }

  function warning(msg: string, duration = 4000): void {
    notify(msg, 'warning', duration);
  }

  function info(msg: string, duration = 3000): void {
    notify(msg, 'info', duration);
  }

  function hide(): void {
    show.value = false;
  }

  return {
    show,
    message,
    color,
    timeout,
    notify,
    success,
    error,
    warning,
    info,
    hide,
  };
});
